import src from "IMAGE";
export default { src, width: 503, height: 401, blurWidth: 0, blurHeight: 0};
